// Max quantity allowed in cart/checkout
export const MAX_QUANTITY = 10;
export const FBC_COOKIE = '_fbc';
export const FBP_COOKIE = '_fbp';
